<div class="body">
	<div class="container">
		<div class="header">
			<h1>Terms and Conditions of Use</h1>
		</div>
		<h2 class="text-uppercase">1. Terms</h2>

		<p>
			By accessing <a href="https://simpleweeklymealplanner.com/"
				>https://simpleweeklymealplanner.com/</a>
			(the Site), you are agreeing to be bound by these Terms and Conditions of Use and agree that you
			are responsible for the agreement with any applicable local laws. If you disagree with any of these
			terms, you are prohibited from accessing the Site. The materials contained here are protected by
			copyright and trademark law.
		</p>

		<h2 class="text-uppercase">2. Use License</h2>

		<p>
			Permission is granted for personal, non-commercial transitory use only. This is the grant of a
			license, not a transfer of title, and under this license you may not:
		</p>

		<ul>
			<li>modify or copy the materials;</li>
			<li>use the materials for any commercial purpose or for any public display;</li>
			<li>attempt to reverse engineer any software contained on the Site</li>
			<li>remove any copyright or other proprietary notations from the materials; or</li>
			<li>
				transfer the materials to another person or "mirror" the materials on any other server.
			</li>
		</ul>

		<p>
			This will let Simple Weekly Meal Planner terminate your usage upon violations of any of these
			restrictions. Upon termination, your viewing right will also be terminated and you should
			destroy any downloaded materials in your possession whether it is printed or electronic
			format.
		</p>

		<h2 class="text-uppercase">3. Disclaimer</h2>

		<p>
			All the materials on the Site are provided "as is". Simple Weekly Meal Planner makes no
			warranties, may it be expressed or implied, therefore negates all other warranties.
			Furthermore, Simple Weekly Meal Planner does not make any representations concerning the
			accuracy or reliability of the use of the materials on its Site or otherwise relating to such
			materials or any sites linked to this Site.
		</p>

		<h2 class="text-uppercase">4. Limitations</h2>

		<p>
			Simple Weekly Meal Planner or its suppliers will not be hold accountable for any damages that
			will arise with the use or inability to the Site, even if an authorized representative of this
			Site has been notified, orally or written, of the possibility of such damage. Some
			jurisdiction does not allow limitations on implied warranties or limitations of liability for
			incidental damages, these limitations may not apply to you.
		</p>

		<h2 class="text-uppercase">5. Revisions and Errata</h2>

		<p>
			The materials appearing on the Site may include technical, typographical, or photographic
			errors. Simple Weekly Meal Planner will not promise that any of the materials in this Site are
			accurate, complete, or current. Simple Weekly Meal Planner may change the materials contained
			on its Site at any time without notice. Simple Weekly Meal Planner does not make any
			commitment to update the materials.
		</p>

		<h2 class="text-uppercase">6. Links</h2>

		<p>
			Simple Weekly Meal Planner has not reviewed all of the sites linked to its Site and is not
			responsible for the contents of any such linked site. The presence of any link does not imply
			endorsement by Simple Weekly Meal Planner of the site. The use of any linked site is at the
			user’s own risk.
		</p>

		<h2 class="text-uppercase">7. Site Terms of Use Modifications</h2>

		<p>
			Simple Weekly Meal Planner may revise these Terms of Use for its Site at any time without
			prior notice. By using this Site, you are agreeing to be bound by the current version of these
			Terms and Conditions of Use.
		</p>

		<h2 class="text-uppercase">8. Your Privacy</h2>

		<p>Please read our <a href="/privacy">Privacy Policy</a>.</p>

		<h2 class="text-uppercase">9. Governing Law</h2>

		<p>
			Any claim related to Simple Weekly Meal Planner's Site shall be governed by the laws of us
			without regards to its conflict of law provisions.
		</p>

		<h2 class="text-uppercase">Contact Us</h2>
		<p>
			For more information about our terms and conditions, if you have questions, or if you would
			like to make a complaint, please contact us by e-mail at help@simpleweeklymealplanner.com.
		</p>
	</div>
</div>

<style>
	.body {
		background: linear-gradient(to right, var(--gradient-start), var(--gradient-end));
		padding: 80px 20px;
	}
	.container {
		max-width: 960px;
		margin: 0 auto;
		padding: 20px;
		background-color: var(--theme-on-primary);
		-webkit-box-shadow: 1px 1px 8px 3px #2d63b2;
		-moz-box-shadow: 1px 1px 8px 3px #2d63b2;
		box-shadow: 1px 1px 8px 3px #2d63b2;
	}

	.header {
		width: 100%;
		text-align: center;
		margin-bottom: 1rem;
		text-transform: uppercase;
	}

	h1 {
		font-size: 2.5rem;
		margin-bottom: 1rem;
	}

	h2 {
		font-size: 1.5rem;
		margin-bottom: 1rem;
	}

	p {
		font-size: 1.125rem;
		line-height: 1.5;
		margin-bottom: 1rem;
	}

	ul {
		padding-left: 1 rem;
	}

	li {
		margin-bottom: 0.5rem;
	}

	a {
		color: #0070f3;
	}
</style>
